import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function addSubs(params) {
  ENABLE_API_DBG &&
    console.log(`api.deptMbrSubs.addSubs: params = ${JSON.stringify(params)}`);
  return request({
    url: `/dept-member-subscription`,
    method: "post",
    data: params,
  });
}

function removeSubs(itemId) {
  const url = `/dept-member-subscription/${itemId}`;
  ENABLE_API_DBG &&
    console.log(`api.deptMbrSubs.removeSubs: url = ${url}`);
  return request({
    url,
    method: "delete",
  });
}

function setApprNeed(itemId, params) {
  return request({
    url: `/dept-member-subscription/${itemId}`,
    method: "patch",
    data: params,
  });
}

export default {
  addSubs,
  removeSubs,
  setApprNeed,
};
